export const ProgressBarBasic = `
<div>
  <ProgressBar now={25} />
  <div className="text-left text-dark">
    <strong>Completed 25 of 100.</strong>
  </div>
</div>
`
export const ProgressBarSmall = `
<ProgressBar now={25} className="progress-sm" />
`
